export default __webpack_public_path__ + "static/media/logo.f4609315.svg";